export default function assignCustomClass() {
  const getColumnWithAccordionItems = document.querySelectorAll('.wp-block-riverdale-accordionitem');

  /* eslint-disable-next-line no-plusplus */
  for (let i = 0; i < getColumnWithAccordionItems.length; i++) {
    if (getColumnWithAccordionItems[i].parentElement.classList.contains('wp-block-column')) {
      getColumnWithAccordionItems[i].parentElement.classList.add('containsAccordions');
    }
  }
}
